/* eslint-disable  no-irregular-whitespace */
import { ArticleHeading5, ArticleParagraph2, Tooltip } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IPriceLabelTooltipProps {
  onOpen?(): void;
  estimationRange: React.ReactChild;
  priceQualityBar: React.ReactElement;
  priceTag: string;
}

export const PriceLabelTooltip: React.FC<IPriceLabelTooltipProps> = props => {
  const { estimationRange, priceQualityBar, priceTag, onOpen } = props;

  return (
    <Tooltip
      title={
        <div className={styles['container']} data-testid="valuation_good_price">
          <ArticleHeading5>Почему цена хорошая</ArticleHeading5>
          <div className={styles['description']}>
            <ArticleParagraph2>
              Хорошей мы считаем цену, которая попадает в диапазон оценки Циан.
              <br />
              Для этой квартиры диапазон:
              <br />
              {estimationRange}
            </ArticleParagraph2>
          </div>
          <div className={styles['price_bar']}>{priceQualityBar}</div>
        </div>
      }
      theme="white"
      placement="right-start"
      onOpen={onOpen}
    >
      <span className={styles['label']} data-testid="valuation_good_price_label">
        {priceTag}
      </span>
    </Tooltip>
  );
};

PriceLabelTooltip.displayName = 'PriceLabelTooltip';
